"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageRotation = exports.ImageAcquisitionStrategy = void 0;
/**
 * The different ways an image can be acquired.
 */
var ImageAcquisitionStrategy;
(function (ImageAcquisitionStrategy) {
    /**
     * The image can be downloaded from a given URL.
     */
    ImageAcquisitionStrategy["DOWNLOAD_FROM_URL"] = "download_from_url";
    /**
     * The image has been uploaded as a multipart form keys.
     */
    ImageAcquisitionStrategy["UPLOAD_MULTIPART_FORM_KEYS"] = "upload_multipart_form_keys";
})(ImageAcquisitionStrategy = exports.ImageAcquisitionStrategy || (exports.ImageAcquisitionStrategy = {}));
/**
 * The different rotations that can be applied to an image when acquiring it.
 *
 * *Swagger Schema Reference :* `ImageRotation`
 */
var ImageRotation;
(function (ImageRotation) {
    /**
     * Apply no rotation to the image.
     */
    ImageRotation["NO_ROTATION"] = "NO_ROTATION";
    /**
     * Apply a 90 degrees clockwise rotation to the image.
     */
    ImageRotation["CLOCKWISE_90"] = "CLOCKWISE_90";
    /**
     * Apply a 180 degrees clockwise rotation to the image.
     */
    ImageRotation["CLOCKWISE_180"] = "CLOCKWISE_180";
    /**
     * Apply a 270 degrees clockwise rotation to the image.
     */
    ImageRotation["CLOCKWISE_270"] = "CLOCKWISE_270";
})(ImageRotation = exports.ImageRotation || (exports.ImageRotation = {}));
//# sourceMappingURL=apiTypes.js.map